module.exports = __webpack_public_path__ + "media/images/riders/small/BARBARA_BENKO-a9e9b12773014e77f0d70e0bfd741b39.png";